export default __webpack_public_path__ + "static/media/step2.5e6f03ed.svg";